document.addEventListener('DOMContentLoaded', function () {
  // We change 'const' to 'let' so we can update the reference if the grid is replaced by filters
  let grid = document.querySelector('[id^="product-grid"]');
  if (!grid) return;

  const sectionId = grid.dataset.id;
  const handle = grid.dataset.collectionHandle;
  const btn = document.querySelector(`#LoadMoreWrap-${sectionId} .btn--load-more`);
  const progressBar = document.querySelector(`#LoadMoreWrap-${sectionId} .load-button__progress-bar`);
  const wrap = document.getElementById(`LoadMoreWrap-${sectionId}`);

  if (!btn) return;

  // Store initial values
  let perPage = parseInt(grid.dataset.productsPerPage, 10);
  let totalProducts = parseInt(grid.dataset.totalProducts, 10);
  let loadedProducts = Math.min(perPage, totalProducts);
  
  // Initialize current page tracking
  let nextPage = 2;
  // We read maxPages dynamically in the click handler now to ensure accuracy
  let maxPages = parseInt(btn.dataset.maxPages, 10);

  const setLoading = (state) => {
    btn.disabled = state;
    btn.textContent = state ? 'Loading…' : 'Load more';
  };

  const updateProgress = () => {
    // Recalculate percent based on current state
    const percent = Math.min((loadedProducts / totalProducts) * 100, 100);
    if (progressBar) {
      progressBar.style.width = `${percent}%`;
    }
  };

  const appendProducts = (html) => {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;

    const newGrid = tmp.querySelector('#product-grid');
    if (!newGrid) return;

    const newItems = tmp.querySelectorAll('.product-card');
    
    // CRITICAL FIX: Always fetch the live grid from the DOM before appending
    const liveGrid = document.querySelector('[id^="product-grid"]');
    
    if (liveGrid && newItems) {
      newItems.forEach((item) => liveGrid.appendChild(item));
      loadedProducts += newItems.length;
      updateProgress();
    }
  };

  const loadMore = async (page) => {
    try {
      setLoading(true);
      const currentParams = window.location.search; 
      const url = `/collections/${handle}${currentParams ? currentParams + '&' : '?'}sections=${sectionId}&page=${page}`;
      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) throw new Error('Bad response');
      const json = await res.json();

      const html = json[sectionId];
      if (!html || !html.trim()) {
        wrap.remove();
        return;
      }

      appendProducts(html);

      nextPage += 1;
      btn.dataset.nextPage = String(nextPage);

      // Re-check max pages in case filters changed the count (though Facets usually doesn't update the button area)
      if (nextPage > maxPages) {
        wrap.remove();
      } else {
        setLoading(false);
      }

    } catch (err) {
      console.error('Error loading more products:', err);
      btn.textContent = 'Retry';
      setLoading(false);
    }
  };

  btn.addEventListener('click', () => {
    // 1. CHECK IF GRID WAS REPLACED (Detection of Filter usage)
    const currentLiveGrid = document.querySelector('[id^="product-grid"]');
    
    // If the grid element currently in the DOM is different from the one we saved initially
    if (currentLiveGrid && currentLiveGrid !== grid) {
      // Update our reference
      grid = currentLiveGrid;
      
      // Reset logic because filters reset the view to Page 1
      nextPage = 2; 
      
      // Update data attributes from the new grid (in case total products changed)
      totalProducts = parseInt(grid.dataset.totalProducts, 10) || totalProducts;
      loadedProducts = parseInt(grid.dataset.productsPerPage, 10) || 22; 
    }

    loadMore(nextPage);
  });

  // Initial update
  updateProgress();
});